var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.countNumber)?_c('div',{staticClass:"notification",attrs:{"title":`New notifications: ${_vm.countNumber}`}},[_c('mailIcon',{staticClass:"notificatin__icon"}),_c('div',{staticClass:"notification__count"},[_vm._v(_vm._s(_vm.countNumber))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }